import { getProductOfferByID } from "../api/api";
import { SequenceManagerAction } from '../actions/SequenceManagerAction';

const ProductOfferAction = {
    LOAD_PRODUCT_OFFER_SUCCESS : 'LOAD_PRODUCT_OFFER_SUCCESS',
    LOAD_PRODUCT_OFFER_FAILURE : 'LOAD_PRODUCT_OFFER_FAILURE'
} as const;

const win: any = window
const retryCount = win['AllowedAPIRetryCount'];

let productOfferCounter = 0;

const getProductOfferById = (productId:String) => {
    return function (dispatch:any) {
        getProductOfferByID(productId).then((response: any) => {
            // let label = response.data?.data?.getProductOfferByID[0]?.offerLabels[0].name
            try {
                if (response?.data?.errors && response?.data?.errors?.length) {
                    dispatch({ type: SequenceManagerAction.GENERIC_ERROR, payload: response });
                } else {
                    dispatch({type: ProductOfferAction.LOAD_PRODUCT_OFFER_SUCCESS, payload:{response:response.data}});
                    dispatch({type: SequenceManagerAction.LOAD_PRODUCT_OFFER_COMPLETE});
                }
            } catch (err) {
                dispatch({ type: SequenceManagerAction.GENERIC_ERROR, payload: err });
            }
        })
        .catch((error) => {
            //Display error
            if (error?.response?.status) {
                dispatch({ type: SequenceManagerAction.GENERIC_ERROR, payload: error });
            } else {
                ++productOfferCounter
                if (productOfferCounter < retryCount) {
                    const pIdString = error?.config?.data ? error?.config?.data.split("\\", 3).pop() : "";
                    const pId = pIdString.startsWith('"') ? pIdString.slice(1) : pIdString;
                    dispatch(getProductOfferById(pId));
                } else {
                    dispatch({ type: SequenceManagerAction.GENERIC_ERROR, payload: error });
                }
            }
        })
    }
}

export { ProductOfferAction, getProductOfferById };